import Tag from "./Tag";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchTags } from "../../features/tags/tagsSlice";
import { clearAll } from "../../features/filter/filterSlice";

export default function Tags() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchTags());
  }, [dispatch]);
  const { tags } = useSelector((state) => state.tags);
  console.log(tags);
  const clearFilter = () => {
    dispatch(clearAll());
  };

  return tags?.length > 0 ? (
    <section>
      <div className="max-w-7xl relative mx-auto px-5 py-6 lg:px-0 flex gap-2 border-b overflow-y-auto">
        {tags?.map((tag) => (
          <Tag title={tag.title} key={tag.id} />
        ))}
        <div
          onClick={clearFilter}
          className="bg-red-600 absoluteright-0 text-white px-4 py-1 rounded-full cursor-pointer"
        >
          Clear Filter
        </div>
      </div>
    </section>
  ) : null;
}
